import { useState } from "react";
import { useDispatch } from "react-redux";
import Button from "../components/button/Button";
import { useNavigate } from "react-router-dom";
import { alertOpen, AlertValue } from "../features/alert.slice";
import { ButtonLoading } from "../components/spinner/Spiner";
import { Result } from "../model/Result";
import authApi from "../api/Auth.api";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import FormController from "../components/fields/FormController";
import { AuthUser, Pass } from "../model/Auth";

export const Register = () => {
  interface RegisterForm {
    email: string;
    password: string;
    confirmPassword: string;
  }

  // バリデーションルール
  const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&].*$/;
  const characterNumberErrorMessage = '8文字以上⼊⼒してください';
  const matchesErrorMessage = "半角 英・数・記号(@$!%*#?&)1文字ずつを含む8文字以上で登録ください";
  const confirmErrorMessage = "入力した内容が一致しません"
  let tempPass = '';
  const schema = yup.object({
    email: yup.string().required().email(),
    password: yup
      .string()
      .required()
      .min(8, characterNumberErrorMessage)
      .matches(
        regex,
        matchesErrorMessage
      ),
    confirmPassword: yup.string().when('password', {
      is:(password: string) => tempPass = password,
      then: (_) => {
        const passRegex = new RegExp(`^${tempPass}$`);
        return yup.string().matches(passRegex, confirmErrorMessage).required();
      }
    }).required(),
  });
  const { control, handleSubmit } = useForm<RegisterForm>({
    resolver: yupResolver(schema),
  });

  const [isload, setIsLoad] = useState(false);
  const navigation = useNavigate();
  const dispatch = useDispatch();

  const onSubmit = async (register: RegisterForm) => {
    //ローディング開始
    setIsLoad(true);

    const auth: AuthUser & Pass = {
      uid: "",
      displayName: "",
      photoUrl: "",
      email: register.email,
      pass: register.password,
    };
    try {
      const result: Result = await authApi.requestCreateStaff(auth, "all");
      if (result.success) {
        navigation("send/", { state: register.email });
        setIsLoad(false);
      } else {
        //エラー時
        const errorMessage = '保存に失敗しました。';
        const subErrorMessage = result.data.response.data.error.code === 'auth/email-already-exists'
          ? 'すでに登録済みのメールアドレスです。'
          : '';
        dispatch(alertOpen(AlertValue(errorMessage, "danger", subErrorMessage)));
      }
      setIsLoad(false);
    } catch (err: any) {
      let errorMessage = err.error.code;
      if (errorMessage === "ERR_NETWORK") {
        dispatch(
          alertOpen(AlertValue("ネットワークに接続できません。", "danger"))
        );
      } else {
        dispatch(alertOpen(AlertValue("保存に失敗しました", "danger")));
      }
      setIsLoad(false);
    }
  };

  return (
    <div className="p-4 space-y-4">
      <h2 className="text-2xl font-bold tracking-tight text-gray-900">
        管理者アカウント作成
      </h2>
      <form
        className="sm:w-full sm:max-w-md space-y-4 px-4"
        onSubmit={handleSubmit(onSubmit)}
        method="POST"
        noValidate
      >
        <FormController
          control={control}
          name={"email"}
          label={"メールアドレス"}
          type={"email"}
        />
        <FormController
          control={control}
          name={"password"}
          label={"パスワード"}
          type={"password"}
        />
        <FormController
          control={control}
          name={"confirmPassword"}
          label={"確認用パスワード"}
          type={"password"}
        />
        <ul>
          <li className="pt-2 text-left block text-xs font-medium text-gray-500">
            ※半角英数字・記号のみ
          </li>
          <li className="text-left block text-xs font-medium text-gray-500">
            ※英・数・記号(@$!%*#?&)1文字ずつを含む8文字以上
          </li>
        </ul>
        <Button submit block disabled={isload}>
          {isload ? <ButtonLoading /> : "新規登録"}
        </Button>
      </form>
    </div>
  );
};
